import styled from 'styled-components';

import { size, rgba } from '../layout/helpers';
import { theme } from '../layout/theme';

export const NavButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${size(4)};
  height: ${size(4)};
  border-radius: 50%;
  background-color: ${theme.colors.bg.alt};
  color: ${theme.colors.text.onColor};
  transform-origin: 50% 50%;
  transition: transform 150ms ease;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${rgba(theme.colors.bg.main, 0.25)};
    border-radius: 50%;
    opacity: 0;
    transition: opacity 150ms ease;
  }

  &:active {
    transform: scale(0.95);
  }

  &:hover {
    &:before {
      opacity: 1;
    }
  }

  &.theme-light {
    background-color: ${theme.colors.bg.main};
    color: ${theme.colors.text.main};

    &:before {
      background-color: ${rgba(theme.colors.bg.alt, 0.05)};
    }
  }
`;
